// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px) and (min-width: 601px)";
var _4 = "wrapper-2T-ap";
var _5 = "header-2qKOB";
var _6 = "title-1IKWM";
var _7 = "subheader-1YHtP";
var _8 = "content-2X_bH";
var _9 = "mainInsurancesList-3TGxm";
var _a = "insurancesList-3bCnN";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet_only", _4 as "wrapper", _5 as "header", _6 as "title", _7 as "subheader", _8 as "content", _9 as "mainInsurancesList", _a as "insurancesList" }
export default { "__esModule": _1, "mobile": _2, "tablet_only": _3, "wrapper": _4, "header": _5, "title": _6, "subheader": _7, "content": _8, "mainInsurancesList": _9, "insurancesList": _a }
